// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for AssistantChatPage.tsx only -- scoped under .ac-root (not :root/body globally, since
   this stylesheet is injected into the whole www bundle by style-loader, and every other route in
   this site keeps its own MUI/dark theme). Tokens/visual language ported from sable's own
   sable.css (mini-brain-business-card-sites.2026-10-07 proposal §7.3/§8.1's owner console) per
   §7.1's own instruction: this page should read as the same product as sable's dashboard, not a
   second design. --accent is set inline per Assistant (the one owner-customizable color, per
   DESIGN-SYSTEM.md's "an accent color, a name/logo, and a short tagline are the only
   owner-customizable elements"); everything else below is fixed. */

html,
body {
  margin: 0;
}

.ac-root {
  --canvas: light-dark(#f4f4f2, #111111);
  --surface: light-dark(#ffffff, #191919);
  --ink: light-dark(#161616, #f2f2f0);
  --fg-2: light-dark(#686868, #a9a9a9);
  --fg-3: light-dark(#8a8a86, #85857f);
  --line: light-dark(#d3d3d0, #383838);
  --row: light-dark(#efefec, #202020);
  --f: "Helvetica Neue", Helvetica, Arial, sans-serif;
  --f-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  color-scheme: light dark;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--canvas);
  color: var(--ink);
  font: 15px/1.5 var(--f);
  /* iOS Safari shows the real <html>/<body> background (usually white) during rubber-band
     overscroll bounce, since this root element's own background doesn't extend past its box --
     fixed properly by also matching html/body to this page's own canvas color while mounted (see
     AssistantChatPage.tsx's useMatchDocumentBackground call), this just stops the bounce from
     happening at all so there's nothing to show through in the first place. Same fix voice-orb.css
     already had for its own root; this was the gap -- chatbot/storyteller never had it. */
  overscroll-behavior: none;
}
.ac-root :focus-visible {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}
.ac-root button,
.ac-root input {
  font: inherit;
  color: inherit;
  border-radius: 0;
}
.ac-root h1,
.ac-root p {
  margin: 0;
}
.ac-mono {
  font-family: var(--f-mono);
}

.ac-shell {
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* ---- Directory / landing state ------------------------------------------------------------- */
.ac-directory {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 28px 20px 16px;
}
.ac-brand-row {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ac-avatar {
  flex: none;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--accent);
  color: #fff;
  display: grid;
  place-items: center;
  font: 600 16px var(--f-mono);
}
.ac-avatar.sm {
  width: 34px;
  height: 34px;
  font-size: 12px;
}
.ac-owner-name {
  font-size: 23px;
  font-weight: 600;
  letter-spacing: -0.04em;
  line-height: 1.15;
}
.ac-business {
  color: var(--fg-2);
  font-size: 13.5px;
  margin-top: 2px;
}
.ac-tagline {
  margin-top: 18px;
  font-size: 16px;
  line-height: 1.5;
}
.ac-info-list {
  margin-top: 22px;
  border-top: 1px solid var(--line);
}
.ac-info-row {
  display: flex;
  gap: 14px;
  padding: 11px 0;
  border-bottom: 1px solid var(--line);
  font-size: 13.5px;
}
.ac-info-row .ac-label {
  flex: none;
  width: 68px;
  font-family: var(--f-mono);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--fg-2);
  padding-top: 2px;
}
.ac-info-row a {
  color: var(--ink);
  text-decoration: underline;
  text-underline-offset: 3px;
}
.ac-links {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ac-cta {
  all: unset;
  box-sizing: border-box;
  display: block;
  text-align: center;
  cursor: pointer;
  margin-top: 22px;
  padding: 14px 18px;
  background: var(--accent);
  color: #fff;
  font-weight: 600;
  font-size: 15px;
}
.ac-cta:hover {
  opacity: 0.9;
}
.ac-ask-row {
  margin-top: auto;
  padding-top: 24px;
}
.ac-ask-hint {
  font-family: var(--f-mono);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--fg-2);
  margin-bottom: 8px;
}

/* ---- Composer (shared between directory + chat) -------------------------------------------- */
.ac-composer {
  position: sticky;
  bottom: 0;
  display: flex;
  gap: 8px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
  background: var(--canvas);
  border-top: 1px solid var(--line);
}
.ac-composer input {
  flex: 1;
  min-width: 0;
  border: 1px solid var(--ink);
  background: var(--surface);
  padding: 11px 12px;
  font-size: 15px;
}
.ac-composer button {
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  padding: 0 18px;
  border: 1px solid var(--ink);
  background: var(--ink);
  color: var(--canvas);
  font-weight: 600;
  font-size: 14px;
  display: grid;
  place-items: center;
}
.ac-composer button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ---- Chat state ----------------------------------------------------------------------------- */
.ac-chat-header {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--canvas);
  border-bottom: 1px solid var(--line);
}
.ac-chat-header-row {
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
}
.ac-chat-header-row:hover {
  background: var(--row);
}
.ac-chat-header-row .ac-owner-name {
  font-size: 15px;
}
.ac-chat-header-row .ac-business {
  font-size: 12px;
  margin-top: 0;
}
.ac-chat-header-row .ac-back {
  margin-left: auto;
  font-family: var(--f-mono);
  font-size: 11px;
  color: var(--fg-2);
}
.ac-disclosure {
  padding: 7px 16px 9px;
  font-family: var(--f-mono);
  font-size: 10.5px;
  letter-spacing: 0.02em;
  color: var(--fg-2);
  line-height: 1.5;
}

.ac-messages {
  flex: 1;
  padding: 16px 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ac-recap {
  border: 1px solid var(--line);
  border-left: 4px solid var(--accent);
  padding: 10px 14px;
  margin-bottom: 4px;
  font-size: 13px;
  background: var(--surface);
}
.ac-recap .ac-mono {
  display: block;
  font-size: 10.5px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--fg-2);
  margin-bottom: 4px;
}
.ac-recap button {
  all: unset;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
  font-size: 12px;
  color: var(--fg-2);
  margin-top: 6px;
  display: inline-block;
}

.ac-msg {
  max-width: 82%;
  padding: 10px 13px;
  font-size: 14.5px;
  line-height: 1.5;
  border: 1px solid var(--line);
}
.ac-msg.visitor {
  align-self: flex-end;
  background: var(--row);
}
.ac-msg.assistant {
  align-self: flex-start;
  background: color-mix(in srgb, var(--accent) 7%, var(--surface));
  border-left: 3px solid var(--accent);
}

.ac-lead {
  align-self: stretch;
  border: 1px solid var(--line);
  background: var(--surface);
  padding: 14px;
  position: relative;
}
.ac-lead-close {
  all: unset;
  position: absolute;
  top: 8px;
  right: 10px;
  cursor: pointer;
  font-family: var(--f-mono);
  font-size: 13px;
  color: var(--fg-2);
  padding: 2px 6px;
}
.ac-lead h3 {
  font-size: 13.5px;
  font-weight: 600;
  margin: 0 20px 4px 0;
}
.ac-lead p {
  color: var(--fg-2);
  font-size: 12.5px;
  margin-bottom: 10px;
}
.ac-lead-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.ac-lead-row input {
  flex: 1;
  min-width: 120px;
  border: 1px solid var(--ink);
  background: var(--canvas);
  padding: 8px 10px;
  font-size: 13.5px;
}
.ac-lead-row button {
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  padding: 8px 14px;
  background: var(--ink);
  color: var(--canvas);
  font-weight: 600;
  font-size: 13px;
}

.ac-chips {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 10px 16px;
  border-top: 1px solid var(--line);
}
.ac-chips button {
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  flex: none;
  padding: 7px 13px;
  border: 1px solid var(--line);
  font-family: var(--f-mono);
  font-size: 12px;
  color: var(--fg-2);
  white-space: nowrap;
}
.ac-chips button:hover {
  border-color: var(--ink);
  color: var(--ink);
}

.ac-footer {
  padding: 14px 16px 22px;
  text-align: center;
}
.ac-footer p {
  font-family: var(--f-mono);
  font-size: 10.5px;
  color: var(--fg-3);
  letter-spacing: 0.03em;
}
.ac-footer button {
  all: unset;
  cursor: pointer;
  font-family: var(--f-mono);
  font-size: 10px;
  color: var(--fg-3);
  text-decoration: underline;
  text-underline-offset: 2px;
  margin-top: 6px;
}

.ac-toast {
  position: fixed;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--ink);
  color: var(--canvas);
  padding: 9px 16px;
  font: 12px var(--f-mono);
  z-index: 60;
}

/* ---- Unknown/unresolved slug fallback -------------------------------------------------------- */
.ac-unknown {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
}
.ac-unknown h1 {
  font-size: 26px;
  letter-spacing: -0.03em;
  margin-bottom: 10px;
}
.ac-unknown p {
  color: var(--fg-2);
  font-size: 14px;
  line-height: 1.55;
}

/* ---- Storyteller presentation type (StorytellerExperience.tsx) ------------------------------- */
.st-shell {
  padding: 0;
}
.st-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 14px;
  border-bottom: 1px solid var(--line);
}
.st-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}
.st-name {
  font-weight: 600;
  font-size: 15px;
}
.st-tagline {
  color: var(--fg-2);
  font-size: 11.5px;
}
.st-icon-btn {
  width: 36px;
  height: 36px;
  border: 1px solid var(--line);
  background: var(--surface);
  font-size: 16px;
  cursor: pointer;
  flex: none;
}
.st-lang-picker {
  position: absolute;
  right: 16px;
  top: 64px;
  background: var(--surface);
  border: 1px solid var(--line);
  z-index: 20;
  min-width: 160px;
}
.st-lang-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-align: left;
  padding: 10px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-bottom: 1px solid var(--line);
}
.st-lang-row:last-child {
  border-bottom: none;
}
.st-lang-row:disabled {
  color: var(--fg-3);
  cursor: default;
}
.st-soon {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.st-intro {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 40px 24px;
  text-align: center;
}
.st-intro-pulse {
  font-size: 48px;
  animation: st-pulse 1.6s ease-in-out infinite;
}
@keyframes st-pulse {
  0%, 100% { transform: scale(1); opacity: 0.85; }
  50% { transform: scale(1.12); opacity: 1; }
}
.st-intro-text {
  color: var(--fg-2);
  font-size: 15px;
}

.st-btn {
  padding: 12px 22px;
  border: 1px solid var(--ink);
  background: var(--surface);
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
}
.st-btn-primary {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

.st-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  color: var(--fg-2);
  text-align: center;
}

.st-list {
  padding: 18px 20px 28px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.st-list-label {
  color: var(--fg-3);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 4px;
}
.st-story-card {
  text-align: left;
  padding: 16px;
  border: 1px solid var(--line);
  background: var(--surface);
  cursor: pointer;
  border-left: 3px solid var(--accent);
}
.st-story-title {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 4px;
}
.st-story-ref {
  color: var(--fg-2);
  font-size: 11.5px;
}

.st-topic-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.st-topic-group + .st-topic-group {
  margin-top: 8px;
}

.st-category-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 8px;
}
.st-category-card {
  text-align: left;
  padding: 18px 16px;
  border: 1px solid var(--line);
  background: var(--accent);
  color: #fff;
  cursor: pointer;
  border-radius: 8px;
}
.st-category-title {
  font-weight: 700;
  font-size: 17px;
  margin-bottom: 4px;
}
.st-category-count {
  color: rgba(255, 255, 255, 0.8);
  font-size: 11.5px;
}

.st-lesson-text {
  white-space: pre-wrap;
}

.st-quiz {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.st-quiz-progress {
  color: var(--fg-3);
}
.st-quiz-question {
  font-size: 17px;
  font-weight: 600;
  line-height: 1.5;
}
.st-quiz-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.st-quiz-option {
  text-align: left;
  padding: 14px 16px;
  border: 1px solid var(--line);
  background: var(--surface);
  cursor: pointer;
  font-size: 15px;
  line-height: 1.4;
}
.st-quiz-option:disabled {
  cursor: default;
}
.st-quiz-option-correct {
  border-color: #1f7a4d;
  background: color-mix(in srgb, #1f7a4d 15%, var(--surface));
}
.st-quiz-option-incorrect {
  border-color: #a4243b;
  background: color-mix(in srgb, #a4243b 15%, var(--surface));
}
.st-quiz-next {
  align-self: flex-start;
}
.st-quiz-done {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  padding: 24px 0;
}
.st-quiz-score {
  font-size: 19px;
  font-weight: 600;
}

.st-player {
  padding: 16px 20px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.st-player-actions {
  display: flex;
  gap: 8px;
}
.st-player-title {
  font-size: 24px;
  letter-spacing: -0.03em;
}
.st-scripture-box {
  background: color-mix(in srgb, var(--accent) 7%, var(--surface));
  border-left: 3px solid var(--accent);
  padding: 14px 16px;
}
.st-scripture-text {
  font-style: italic;
  line-height: 1.6;
  margin-top: 6px;
  color: var(--fg-2);
}
.st-audio {
  width: 100%;
}
.st-no-audio {
  color: var(--fg-3);
  font-size: 12.5px;
}
.st-story-text {
  line-height: 1.8;
  font-size: 16px;
  white-space: pre-wrap;
}
.st-word {
  transition: background-color 0.15s ease, text-shadow 0.15s ease;
  border-radius: 4px;
}
.st-word-active {
  background: color-mix(in srgb, var(--accent) 28%, transparent);
  text-shadow: 0 0 10px color-mix(in srgb, var(--accent) 70%, transparent);
  font-weight: 600;
}
.st-closing-line {
  font-style: italic;
  color: var(--fg-2);
  border-top: 1px solid var(--line);
  padding-top: 14px;
}

.st-format-toggle {
  display: flex;
  gap: 8px;
}
.st-format-btn {
  padding: 8px 16px;
  border: 1px solid var(--line);
  background: var(--surface);
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}
.st-format-active {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

.st-skit {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.st-skit-cast {
  color: var(--fg-3);
  font-size: 11px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;
}
.st-cast-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.st-cast-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--char-color, var(--accent));
  display: inline-block;
}
.st-skit-lines {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.st-skit-line {
  padding: 12px 14px;
  border-left: 3px solid var(--char-color, var(--line));
  background: var(--surface);
  opacity: 0.55;
  transition: opacity 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}
.st-skit-line-active {
  opacity: 1;
  background: color-mix(in srgb, var(--char-color, var(--accent)) 8%, var(--surface));
}
.st-skit-line .st-word-active {
  background: color-mix(in srgb, var(--char-color, var(--accent)) 30%, transparent);
  text-shadow: 0 0 10px color-mix(in srgb, var(--char-color, var(--accent)) 70%, transparent);
}
.st-skit-character {
  font-weight: 700;
  font-size: 11.5px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--char-color, var(--accent));
  margin-bottom: 4px;
}
.st-skit-text {
  line-height: 1.6;
  font-size: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/assistant-chat.css"],"names":[],"mappings":"AAAA;;;;;;;mEAOmE;;AAEnE;;EAEE,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,mDAAmD;EACnD,kEAAkE;EAClE,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB;;;;;0FAKwF;EACxF,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,iGAAiG;AACjG;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iGAAiG;AACjG;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,QAAQ;EACR,gEAAgE;EAChE,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,OAAO;EACP,YAAY;EACZ,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kGAAkG;AAClG;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,gEAAgE;EAChE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;;AAEA,mGAAmG;AACnG;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,mGAAmG;AACnG;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,6CAA6C;AAC/C;AACA;EACE,WAAW,mBAAmB,EAAE,aAAa,EAAE;EAC/C,MAAM,sBAAsB,EAAE,UAAU,EAAE;AAC5C;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,2DAA2D;AAC7D;AACA;EACE,qBAAqB;EACrB,2DAA2D;AAC7D;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gEAAgE;EAChE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,+DAA+D;EAC/D,kBAAkB;AACpB;AACA;EACE,8DAA8D;EAC9D,wEAAwE;EACxE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,0BAA0B;EAC1B,aAAa;EACb,2EAA2E;AAC7E;AACA;EACE,UAAU;EACV,mFAAmF;AACrF;AACA;EACE,iFAAiF;EACjF,2FAA2F;AAC7F;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* Styles for AssistantChatPage.tsx only -- scoped under .ac-root (not :root/body globally, since\n   this stylesheet is injected into the whole www bundle by style-loader, and every other route in\n   this site keeps its own MUI/dark theme). Tokens/visual language ported from sable's own\n   sable.css (mini-brain-business-card-sites.2026-10-07 proposal §7.3/§8.1's owner console) per\n   §7.1's own instruction: this page should read as the same product as sable's dashboard, not a\n   second design. --accent is set inline per Assistant (the one owner-customizable color, per\n   DESIGN-SYSTEM.md's \"an accent color, a name/logo, and a short tagline are the only\n   owner-customizable elements\"); everything else below is fixed. */\n\nhtml,\nbody {\n  margin: 0;\n}\n\n.ac-root {\n  --canvas: light-dark(#f4f4f2, #111111);\n  --surface: light-dark(#ffffff, #191919);\n  --ink: light-dark(#161616, #f2f2f0);\n  --fg-2: light-dark(#686868, #a9a9a9);\n  --fg-3: light-dark(#8a8a86, #85857f);\n  --line: light-dark(#d3d3d0, #383838);\n  --row: light-dark(#efefec, #202020);\n  --f: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  --f-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  color-scheme: light dark;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--canvas);\n  color: var(--ink);\n  font: 15px/1.5 var(--f);\n  /* iOS Safari shows the real <html>/<body> background (usually white) during rubber-band\n     overscroll bounce, since this root element's own background doesn't extend past its box --\n     fixed properly by also matching html/body to this page's own canvas color while mounted (see\n     AssistantChatPage.tsx's useMatchDocumentBackground call), this just stops the bounce from\n     happening at all so there's nothing to show through in the first place. Same fix voice-orb.css\n     already had for its own root; this was the gap -- chatbot/storyteller never had it. */\n  overscroll-behavior: none;\n}\n.ac-root :focus-visible {\n  outline: 2px solid var(--ink);\n  outline-offset: 2px;\n}\n.ac-root button,\n.ac-root input {\n  font: inherit;\n  color: inherit;\n  border-radius: 0;\n}\n.ac-root h1,\n.ac-root p {\n  margin: 0;\n}\n.ac-mono {\n  font-family: var(--f-mono);\n}\n\n.ac-shell {\n  max-width: 480px;\n  margin: 0 auto;\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* ---- Directory / landing state ------------------------------------------------------------- */\n.ac-directory {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 28px 20px 16px;\n}\n.ac-brand-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.ac-avatar {\n  flex: none;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--accent);\n  color: #fff;\n  display: grid;\n  place-items: center;\n  font: 600 16px var(--f-mono);\n}\n.ac-avatar.sm {\n  width: 34px;\n  height: 34px;\n  font-size: 12px;\n}\n.ac-owner-name {\n  font-size: 23px;\n  font-weight: 600;\n  letter-spacing: -0.04em;\n  line-height: 1.15;\n}\n.ac-business {\n  color: var(--fg-2);\n  font-size: 13.5px;\n  margin-top: 2px;\n}\n.ac-tagline {\n  margin-top: 18px;\n  font-size: 16px;\n  line-height: 1.5;\n}\n.ac-info-list {\n  margin-top: 22px;\n  border-top: 1px solid var(--line);\n}\n.ac-info-row {\n  display: flex;\n  gap: 14px;\n  padding: 11px 0;\n  border-bottom: 1px solid var(--line);\n  font-size: 13.5px;\n}\n.ac-info-row .ac-label {\n  flex: none;\n  width: 68px;\n  font-family: var(--f-mono);\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--fg-2);\n  padding-top: 2px;\n}\n.ac-info-row a {\n  color: var(--ink);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n.ac-links {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.ac-cta {\n  all: unset;\n  box-sizing: border-box;\n  display: block;\n  text-align: center;\n  cursor: pointer;\n  margin-top: 22px;\n  padding: 14px 18px;\n  background: var(--accent);\n  color: #fff;\n  font-weight: 600;\n  font-size: 15px;\n}\n.ac-cta:hover {\n  opacity: 0.9;\n}\n.ac-ask-row {\n  margin-top: auto;\n  padding-top: 24px;\n}\n.ac-ask-hint {\n  font-family: var(--f-mono);\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--fg-2);\n  margin-bottom: 8px;\n}\n\n/* ---- Composer (shared between directory + chat) -------------------------------------------- */\n.ac-composer {\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  gap: 8px;\n  padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));\n  background: var(--canvas);\n  border-top: 1px solid var(--line);\n}\n.ac-composer input {\n  flex: 1;\n  min-width: 0;\n  border: 1px solid var(--ink);\n  background: var(--surface);\n  padding: 11px 12px;\n  font-size: 15px;\n}\n.ac-composer button {\n  all: unset;\n  box-sizing: border-box;\n  cursor: pointer;\n  padding: 0 18px;\n  border: 1px solid var(--ink);\n  background: var(--ink);\n  color: var(--canvas);\n  font-weight: 600;\n  font-size: 14px;\n  display: grid;\n  place-items: center;\n}\n.ac-composer button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ---- Chat state ----------------------------------------------------------------------------- */\n.ac-chat-header {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: var(--canvas);\n  border-bottom: 1px solid var(--line);\n}\n.ac-chat-header-row {\n  all: unset;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 12px 16px;\n}\n.ac-chat-header-row:hover {\n  background: var(--row);\n}\n.ac-chat-header-row .ac-owner-name {\n  font-size: 15px;\n}\n.ac-chat-header-row .ac-business {\n  font-size: 12px;\n  margin-top: 0;\n}\n.ac-chat-header-row .ac-back {\n  margin-left: auto;\n  font-family: var(--f-mono);\n  font-size: 11px;\n  color: var(--fg-2);\n}\n.ac-disclosure {\n  padding: 7px 16px 9px;\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.02em;\n  color: var(--fg-2);\n  line-height: 1.5;\n}\n\n.ac-messages {\n  flex: 1;\n  padding: 16px 16px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.ac-recap {\n  border: 1px solid var(--line);\n  border-left: 4px solid var(--accent);\n  padding: 10px 14px;\n  margin-bottom: 4px;\n  font-size: 13px;\n  background: var(--surface);\n}\n.ac-recap .ac-mono {\n  display: block;\n  font-size: 10.5px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--fg-2);\n  margin-bottom: 4px;\n}\n.ac-recap button {\n  all: unset;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  font-size: 12px;\n  color: var(--fg-2);\n  margin-top: 6px;\n  display: inline-block;\n}\n\n.ac-msg {\n  max-width: 82%;\n  padding: 10px 13px;\n  font-size: 14.5px;\n  line-height: 1.5;\n  border: 1px solid var(--line);\n}\n.ac-msg.visitor {\n  align-self: flex-end;\n  background: var(--row);\n}\n.ac-msg.assistant {\n  align-self: flex-start;\n  background: color-mix(in srgb, var(--accent) 7%, var(--surface));\n  border-left: 3px solid var(--accent);\n}\n\n.ac-lead {\n  align-self: stretch;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  padding: 14px;\n  position: relative;\n}\n.ac-lead-close {\n  all: unset;\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  cursor: pointer;\n  font-family: var(--f-mono);\n  font-size: 13px;\n  color: var(--fg-2);\n  padding: 2px 6px;\n}\n.ac-lead h3 {\n  font-size: 13.5px;\n  font-weight: 600;\n  margin: 0 20px 4px 0;\n}\n.ac-lead p {\n  color: var(--fg-2);\n  font-size: 12.5px;\n  margin-bottom: 10px;\n}\n.ac-lead-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.ac-lead-row input {\n  flex: 1;\n  min-width: 120px;\n  border: 1px solid var(--ink);\n  background: var(--canvas);\n  padding: 8px 10px;\n  font-size: 13.5px;\n}\n.ac-lead-row button {\n  all: unset;\n  box-sizing: border-box;\n  cursor: pointer;\n  padding: 8px 14px;\n  background: var(--ink);\n  color: var(--canvas);\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.ac-chips {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  padding: 10px 16px;\n  border-top: 1px solid var(--line);\n}\n.ac-chips button {\n  all: unset;\n  box-sizing: border-box;\n  cursor: pointer;\n  flex: none;\n  padding: 7px 13px;\n  border: 1px solid var(--line);\n  font-family: var(--f-mono);\n  font-size: 12px;\n  color: var(--fg-2);\n  white-space: nowrap;\n}\n.ac-chips button:hover {\n  border-color: var(--ink);\n  color: var(--ink);\n}\n\n.ac-footer {\n  padding: 14px 16px 22px;\n  text-align: center;\n}\n.ac-footer p {\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  color: var(--fg-3);\n  letter-spacing: 0.03em;\n}\n.ac-footer button {\n  all: unset;\n  cursor: pointer;\n  font-family: var(--f-mono);\n  font-size: 10px;\n  color: var(--fg-3);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  margin-top: 6px;\n}\n\n.ac-toast {\n  position: fixed;\n  bottom: 18px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--ink);\n  color: var(--canvas);\n  padding: 9px 16px;\n  font: 12px var(--f-mono);\n  z-index: 60;\n}\n\n/* ---- Unknown/unresolved slug fallback -------------------------------------------------------- */\n.ac-unknown {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  text-align: center;\n}\n.ac-unknown h1 {\n  font-size: 26px;\n  letter-spacing: -0.03em;\n  margin-bottom: 10px;\n}\n.ac-unknown p {\n  color: var(--fg-2);\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n/* ---- Storyteller presentation type (StorytellerExperience.tsx) ------------------------------- */\n.st-shell {\n  padding: 0;\n}\n.st-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 20px 14px;\n  border-bottom: 1px solid var(--line);\n}\n.st-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.st-name {\n  font-weight: 600;\n  font-size: 15px;\n}\n.st-tagline {\n  color: var(--fg-2);\n  font-size: 11.5px;\n}\n.st-icon-btn {\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  font-size: 16px;\n  cursor: pointer;\n  flex: none;\n}\n.st-lang-picker {\n  position: absolute;\n  right: 16px;\n  top: 64px;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  z-index: 20;\n  min-width: 160px;\n}\n.st-lang-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  text-align: left;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-bottom: 1px solid var(--line);\n}\n.st-lang-row:last-child {\n  border-bottom: none;\n}\n.st-lang-row:disabled {\n  color: var(--fg-3);\n  cursor: default;\n}\n.st-soon {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.st-intro {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  padding: 40px 24px;\n  text-align: center;\n}\n.st-intro-pulse {\n  font-size: 48px;\n  animation: st-pulse 1.6s ease-in-out infinite;\n}\n@keyframes st-pulse {\n  0%, 100% { transform: scale(1); opacity: 0.85; }\n  50% { transform: scale(1.12); opacity: 1; }\n}\n.st-intro-text {\n  color: var(--fg-2);\n  font-size: 15px;\n}\n\n.st-btn {\n  padding: 12px 22px;\n  border: 1px solid var(--ink);\n  background: var(--surface);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n}\n.st-btn-primary {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #fff;\n}\n\n.st-empty {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 24px;\n  color: var(--fg-2);\n  text-align: center;\n}\n\n.st-list {\n  padding: 18px 20px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.st-list-label {\n  color: var(--fg-3);\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 4px;\n}\n.st-story-card {\n  text-align: left;\n  padding: 16px;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  cursor: pointer;\n  border-left: 3px solid var(--accent);\n}\n.st-story-title {\n  font-weight: 600;\n  font-size: 15px;\n  margin-bottom: 4px;\n}\n.st-story-ref {\n  color: var(--fg-2);\n  font-size: 11.5px;\n}\n\n.st-topic-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.st-topic-group + .st-topic-group {\n  margin-top: 8px;\n}\n\n.st-category-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n.st-category-card {\n  text-align: left;\n  padding: 18px 16px;\n  border: 1px solid var(--line);\n  background: var(--accent);\n  color: #fff;\n  cursor: pointer;\n  border-radius: 8px;\n}\n.st-category-title {\n  font-weight: 700;\n  font-size: 17px;\n  margin-bottom: 4px;\n}\n.st-category-count {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 11.5px;\n}\n\n.st-lesson-text {\n  white-space: pre-wrap;\n}\n\n.st-quiz {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.st-quiz-progress {\n  color: var(--fg-3);\n}\n.st-quiz-question {\n  font-size: 17px;\n  font-weight: 600;\n  line-height: 1.5;\n}\n.st-quiz-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.st-quiz-option {\n  text-align: left;\n  padding: 14px 16px;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  cursor: pointer;\n  font-size: 15px;\n  line-height: 1.4;\n}\n.st-quiz-option:disabled {\n  cursor: default;\n}\n.st-quiz-option-correct {\n  border-color: #1f7a4d;\n  background: color-mix(in srgb, #1f7a4d 15%, var(--surface));\n}\n.st-quiz-option-incorrect {\n  border-color: #a4243b;\n  background: color-mix(in srgb, #a4243b 15%, var(--surface));\n}\n.st-quiz-next {\n  align-self: flex-start;\n}\n.st-quiz-done {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 24px 0;\n}\n.st-quiz-score {\n  font-size: 19px;\n  font-weight: 600;\n}\n\n.st-player {\n  padding: 16px 20px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.st-player-actions {\n  display: flex;\n  gap: 8px;\n}\n.st-player-title {\n  font-size: 24px;\n  letter-spacing: -0.03em;\n}\n.st-scripture-box {\n  background: color-mix(in srgb, var(--accent) 7%, var(--surface));\n  border-left: 3px solid var(--accent);\n  padding: 14px 16px;\n}\n.st-scripture-text {\n  font-style: italic;\n  line-height: 1.6;\n  margin-top: 6px;\n  color: var(--fg-2);\n}\n.st-audio {\n  width: 100%;\n}\n.st-no-audio {\n  color: var(--fg-3);\n  font-size: 12.5px;\n}\n.st-story-text {\n  line-height: 1.8;\n  font-size: 16px;\n  white-space: pre-wrap;\n}\n.st-word {\n  transition: background-color 0.15s ease, text-shadow 0.15s ease;\n  border-radius: 4px;\n}\n.st-word-active {\n  background: color-mix(in srgb, var(--accent) 28%, transparent);\n  text-shadow: 0 0 10px color-mix(in srgb, var(--accent) 70%, transparent);\n  font-weight: 600;\n}\n.st-closing-line {\n  font-style: italic;\n  color: var(--fg-2);\n  border-top: 1px solid var(--line);\n  padding-top: 14px;\n}\n\n.st-format-toggle {\n  display: flex;\n  gap: 8px;\n}\n.st-format-btn {\n  padding: 8px 16px;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n}\n.st-format-active {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #fff;\n}\n\n.st-skit {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.st-skit-cast {\n  color: var(--fg-3);\n  font-size: 11px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 2px;\n}\n.st-cast-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n.st-cast-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--char-color, var(--accent));\n  display: inline-block;\n}\n.st-skit-lines {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.st-skit-line {\n  padding: 12px 14px;\n  border-left: 3px solid var(--char-color, var(--line));\n  background: var(--surface);\n  opacity: 0.55;\n  transition: opacity 0.2s ease, border-color 0.2s ease, background 0.2s ease;\n}\n.st-skit-line-active {\n  opacity: 1;\n  background: color-mix(in srgb, var(--char-color, var(--accent)) 8%, var(--surface));\n}\n.st-skit-line .st-word-active {\n  background: color-mix(in srgb, var(--char-color, var(--accent)) 30%, transparent);\n  text-shadow: 0 0 10px color-mix(in srgb, var(--char-color, var(--accent)) 70%, transparent);\n}\n.st-skit-character {\n  font-weight: 700;\n  font-size: 11.5px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--char-color, var(--accent));\n  margin-bottom: 4px;\n}\n.st-skit-text {\n  line-height: 1.6;\n  font-size: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
